module.exports = __webpack_public_path__ + "static/media/plus.56c6406d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Equipments/images/plus.svg
// module id = 1081
// module chunks = 0